import { useEffect, useState } from "react";
import { useModal } from "../../hooks/useModal";
import { Text } from "rizzui/typography";
import { Button } from "rizzui/button";
import { ActionIcon } from "rizzui/action-icon";
import cn from "../../lib/utils/class-name";
import CheckIcon from "../../assets/checkIcon";
import { Field, type } from "./dataMapping";

export default function ExtraFields({
  submitFunction,
  selectedFields = [],
  type,
  fields = [],
}: {
  submitFunction: React.Dispatch<React.SetStateAction<Field[]>>;
  selectedFields?: Field[];
  type: type;
  fields?: Field[];
}) {
  const { closeModal, isOpen } = useModal();
  const [selected, setSeletced] = useState<Field[] | null>();

  useEffect(() => {
    isOpen === false && setSeletced([]);
  }, [isOpen]);

  useEffect(() => {
    if (selectedFields.length > 0) {
      setSeletced(selectedFields);
    } else {
      setSeletced([]);
    }
  }, [selectedFields]);

  const handleClick = (field: Field) => {
    setSeletced((prev) => {
      if (prev?.includes(field)) {
        return prev.filter((f) => f !== field);
      } else {
        return [...(prev || []), field];
      }
    });
  };

  return (
    <div className="md:w-[503px] w-[96%] bg-background dark:bg-[#2A2C30] rounded-[8px] p-[32px] mx-auto">
      <button
        className="absolute top-4 right-4 p-1 rounded-lg z-10 text-gray-400 bg-transparent hover:text-gray-600 dark:hover:text-gray-300"
        onClick={closeModal}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="size-[18px]"
        >
          <path
            fillRule="evenodd"
            d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      <div className="flex flex-col gap-[40px]">
        <div className="flex flex-col gap-[8px]">
          <Text className="text-primary-dark font-ibmPlexSerif font-[600] text-[18px] leading-[23.4px]">
            Select fields to map
          </Text>

          <Text className="text-[#758599] font-switzer text-[14px] w-[379px]">
            You can select more than one fields to include in the data mapping
            process
          </Text>
        </div>

        <div className="flex flex-wrap gap-[14px] h-[200px] border border-muted rounded-[8px] px-[20px] py-[15px] overflow-y-auto customBar">
          {fields.map((field, index) => (
            <ActionIcon
              key={index}
              onClick={() => handleClick(field)}
              className={cn(
                "!w-fit !h-fit !bg-transparent flex items-center gap-[5px] px-[8px] py-[6px] rounded-full border",
                selected?.includes(field)
                  ? "border-primary-dark"
                  : "border-muted"
              )}
            >
              {selected?.some(
                (item) => item.ringconnect === field.ringconnect
              ) && (
                <div className="size-[11px] flex justify-center items-center !bg-btn rounded-full">
                  <CheckIcon className={"text-background size-[5.5px]"} />
                </div>
              )}
              <Text
                className={cn(
                  "font-switzer font-[400] text-[12px]",
                  selected?.includes(field)
                    ? "text-primary-dark"
                    : "text-[#758599]"
                )}
              >
                {field[type]?.charAt(0).toUpperCase() + field[type]?.slice(1)}
              </Text>
            </ActionIcon>
          ))}
        </div>

        <Button
          className="!bg-btn w-full rounded-[4px] h-[40px] disabled:!bg-[#758599]"
          disabled={selected?.length === 0}
          onClick={() => {
            submitFunction(selected || []);
            closeModal();
          }}
        >
          <Text className="font-switzer text-[12px] font-[500] text-background">
            Submit
          </Text>
        </Button>
      </div>
    </div>
  );
}
